<template>
  <div class="suggest-card" :style="{top: `${top}px`}">
    <div class="header flex-between">
      <div class="flex-start">
        <span class="iconfont iconcuowu"/>
        <span>{{ suggestInfo.errorName || '错误信息' }}</span>
      </div>
      <span class="iconfont iconx" @click="handleClose"/>
    </div>
    <div class="error-description">{{ suggestInfo.errorDescription }}</div>
  </div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		name: 'suggest-card',
		props: {
			top: {
				type: [ Number, String ],
				default: 88
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {
			...mapState('cv', [ 'suggestInfo' ]),
			errorInfo () {
				return this.$db.ls.get('errorInfo')
			}
		},
		watch: {},
		components: {},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .suggest-card {
    width: calc(100vw - 48px);
    padding: 20px 18px;
    background-color: #4e505e;
    color: $color-light;
    border-radius: 4px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
    position: absolute;
    z-index: 19;
    left: 50%;
    transform: translateX(-50%);
    .header {
      margin-bottom: 20px;
      font-weight: 500;
      .iconcuowu {
        margin-right: 10px;
      }
    }
    .error-description {
      line-height: 20px;
    }
  }
</style>
